import React, { useCallback } from 'react';

import { FactureAchat, useAchatsService, useSociete } from '@europrocurement/l2d-domain';
import { Typography } from '@mui/material';
import { AxiosError } from 'axios';
import { useSnackbar } from 'notistack';
import { FactureAchatApiGetReindexFactureAchatItemRequest } from '@europrocurement/l2d-domain/openApi/ApiAchats';

export const useReindexOpenSearchFacture = () => {
    const { enqueueSnackbar } = useSnackbar();
    const xIdSociete = useSociete();
    const { factureAchatApi } = useAchatsService();

    const reindexOpenSearchFacture = useCallback(
        async (factureAchat: FactureAchat, societe?: number) => {
            if (!factureAchat.id) {
                enqueueSnackbar(
                    <Typography>
                        Erreur technique la facture n&apos;a pas d&apos;identifiant
                    </Typography>,
                    { variant: 'warning' },
                );
                return;
            }
            try {
                const requestParameters: FactureAchatApiGetReindexFactureAchatItemRequest = {
                    xIdSociete: societe ?? xIdSociete,
                    id: `${factureAchat.id}`,
                };

                const res = await factureAchatApi.getReindexFactureAchatItem(requestParameters);

                if (res.status >= 200 && res.status < 300) {
                    enqueueSnackbar(<Typography>Réindexation OpenSearch en cours</Typography>, {
                        variant: 'success',
                    });
                } else {
                    throw new Error(`Erreur ${res.status}`);
                }
            } catch (error) {
                if (
                    error instanceof AxiosError &&
                    error.response &&
                    error.response.data.exception &&
                    error.response.data.exception.message
                ) {
                    enqueueSnackbar(
                        <Typography>{error.response.data.exception.message}</Typography>,
                        {
                            variant: 'error',
                        },
                    );
                } else if (error instanceof Error) {
                    enqueueSnackbar(<Typography>{error.message}</Typography>, {
                        variant: 'error',
                    });
                }
            }
        },
        [enqueueSnackbar, factureAchatApi, xIdSociete],
    );

    return { reindexOpenSearchFacture };
};
